<template>
    <div class="screenshot-name">
        <div class="text-truncate">
            <a href @click.prevent="showScreenshot = true">{{ filename || value }}</a>
        </div>

        <VueEasyLightbox
            v-if="value"
            :visible="showScreenshot"
            :imgs="[value]"
            :index="0"
            @hide="showScreenshot = false"
        >
            <template v-slot:toolbar>&nbsp;</template>
        </VueEasyLightbox>
    </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
export default {
    name: "StreamScreenshotValue",
    components: {
        VueEasyLightbox
    },
    props: ['value', 'filename'],
    data() {
        return {
            showScreenshot: false,
        }
    },
}
</script>
